import { Region } from "src/app/model/region.model";




export class EditableStudentCommunicationEvent {
	isEdit: boolean;
	isDelete?: boolean = false;
	studentCommunicationEvent: StudentCommunicationEvent;
}

export class StudentCommunicationEvents {
	studentCommunicationEvents: StudentCommunicationEvent[];
}
export class StudentCommunicationEvent {
	ID: number;
	COMMUNICATION_DATE: Date;
	STUDENTS_ID: number;
	COMMUNICATION_EVENT_PURPOSE_TYPES_ID: number;
	MERGED_RECORD: number;
	CREATED_BY: string;
	CREATED_DATE?: Date; // "/Date(1482326259893)/",
	MODIFIED_BY: any;
	MODIFIED_DATE: any;
	COMMENTS: string;
	REGIONS_ID: number;
	COMMUNICATION_EVENT_PURPOSE_TYPES: CommunicationEventPurposeType;
	STUDENT: any;
	REGION: Region;
	STUDENT_COMMUNICATION_EVENT_PROPERTIES: StudentCommunicationEventProperties[];
}

export class CommunicationEventPurposeType {
	ID: number;
	TYPE: string;
	DESCRIPTION: string;
	CREATED_BY: any;
	CREATED_DATE: string;
	MODIFIED_BY: any;
	MODIFIED_DATE: any;
	COMMUNICATION_EVENT_PURPOSES: any[];
	STUDENT_COMMUNICATION_EVENTS: any[];
	COMMUNICATION_EVENT_PURPOSE_PROPERTIES: CommunicationEventPurposeProperties[];
}

export class CommunicationEventPurposeProperties {
	ID: number;
	COMMUNICATION_EVENT_PURPOSE_TYPES_ID: number;
	COMMUNICATION_EVENT_PURPOSE_PROPERTY_TYPES_ID: number;
	CREATED_BY: any;
	CREATED_DATE: string;
	MODIFIED_BY: any;
	MODIFIED_DATE: any;
	COMMUNICATION_EVENT_PURPOSE_TYPES: CommunicationEventPurposeType;
	COMMUNICATION_EVENT_PURPOSE_PROPERTY_TYPES: CommunicationEventPurposePropertyTypes;
}


export class StudentCommunicationEventProperties {
	ID: number;
	STUDENT_COMMUNICATION_EVENTS_ID: number;
	COMMUNICATION_EVENT_PURPOSE_PROPERTY_TYPES_ID: number;
	CREATED_BY: any;
	CREATED_DATE: string;
	MODIFIED_BY: any;
	MODIFIED_DATE: any;
	STUDENT_COMMUNICATION_EVENTS: StudentCommunicationEvents;
	COMMUNICATION_EVENT_PURPOSE_PROPERTY_TYPES: CommunicationEventPurposePropertyTypes;
}

export interface StudentCommunicationEvents {
	ID: number;
	COMMUNICATION_DATE: string;
	STUDENTS_ID: number;
	COMMUNICATION_EVENT_PURPOSE_TYPES_ID: number;
	MERGED_RECORD: number;
	CREATED_BY: any;
	CREATED_DATE: string;
	MODIFIED_BY: any;
	MODIFIED_DATE: any;
	COMMENTS: any;
	REGIONS_ID: number;
	COMMUNICATION_EVENT_PURPOSE_TYPES: any;
	STUDENT: any;
	REGION: any;
	STUDENT_COMMUNICATION_EVENT_PROPERTIES: any[];
}

export class CommunicationEventPurposePropertyTypes {
	ID: number;
	TYPE: string;
	DESCRIPTION: string;
	CREATED_BY: any;
	CREATED_DATE: string;
	MODIFIED_BY: any;
	MODIFIED_DATE: any;
}
